






























































import { Component, Watch, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import ListUtils from '@/lib/listUtils';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductListModule } from '@/store/Products/ProductListModule';
import FixedTermMaturityType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityType";
import FixedTermMaturityActionType from '@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityActionType';
import PeriodType from '@/models/Shared/PeriodType';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ProductSubType from '@/models/Products/ProductSubType';
import MaturityAction1ProductSelectionType from '@/models/Products/MaturityAction1ProductSelectionType';

@Component({ name: 'DepositFixedTermMaturitySettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    FixedTermMaturityType = FixedTermMaturityType;
    PeriodType = PeriodType;
    MaturityAction1ProductSelectionType = MaturityAction1ProductSelectionType;

    maturityAction1ProductSelectionType = MaturityAction1ProductSelectionType.ThisNewProduct;

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    async beforeMount() {
        await ProductListModule.getProducts(1);
    }

    @Watch('productVM.depositFixedTermMaturitySettings.maturityType')
    async onMaturityTypeChanged() {
        if (this.productVM.depositFixedTermMaturitySettings.maturityType === FixedTermMaturityType.ReinvestFullBalance) {
            this.productVM.depositFixedTermMaturitySettings.maturityAction1Type = FixedTermMaturityActionType.Reinvest;
        }
        else {
            this.productVM.depositFixedTermMaturitySettings.maturityAction1Type = FixedTermMaturityActionType.Withdrawal;
        }
    }

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.DepositFixedTerm) {
                ProductWizardModule.createProductViewModel.depositFixedTermMaturitySettingsAvailable = true;
            }
           return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get isReinvestFullBalance() {
        return this.productVM.depositFixedTermMaturitySettings.maturityType === FixedTermMaturityType.ReinvestFullBalance;
    }

    get isReinvestInDifferentProduct() {
        return this.maturityAction1ProductSelectionType === MaturityAction1ProductSelectionType.DifferentProduct;
    }

    get depositMaturityActionOptions() {
        return ListUtils.fixedTermMaturityTypesForProductLevel();
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get maturityProductOptions() {
        // Only show products of specific sub types
        return ProductListModule.products.filter(product => product.generalSettings.subType === "DEPOSIT_FIXED_TERM" || product.generalSettings.subType === "DEPOSIT_SAVINGS_ACCOUNT");
    }

}
